import React from 'react';
import { useSearchParams } from 'react-router-dom';
import GenericTable from './GenericTable';
import {
  fetchShipmentsByPage,
  fetchClientsByPage,
  fetchCarrierByPage,
  fetchInvoiceByPage,
} from '../../services/api';
import { applyColumnDisplayRules } from '../../config/columnDisplayRules';
import './genericTableParamSetter.css';

export default function GenericTableParamSetter({ data_type, layout }) {
  const [searchParams] = useSearchParams();
  const shipmentStage = searchParams.get('shipment_stage');

  let tableTitle = '';
  let data_identifier = '';
  let columns = [];
  let fetchFunction;
  let url = '/';
  let headerClass = layout;

  // Set data_type specific parameters
  if (data_type === 'shipment') {
    if (layout === 'shipment') {
      tableTitle = 'Dossiers';
      data_identifier = 'shipment_number';
      url = '/dossiers/';
    } else if (layout === 'pre-fac') {
      tableTitle = 'Pré-fac';
      data_identifier = 'shipment_number';
      url = '/pre-fac/';
    } else if (layout === 'carrier-billing') {
      tableTitle = 'Facturation transporteurs';
      data_identifier = 'shipment_number';
      url = '/facturation-tps/';
    } else if (layout === 'deleted') {
      tableTitle = 'Dossiers supprimés';
      data_identifier = 'shipment_number';
      url = '/supprimes/';
    }
    fetchFunction = fetchShipmentsByPage;
    columns = [
      { name: 'Numéro', dataField: 'shipment_number', type: 'text' },
      { name: 'Date affret', dataField: 'chartering_datetime', type: 'date' },
      { name: 'Code client', dataField: 'client', type: 'text' },
      { name: 'Code tps', dataField: 'carrier', type: 'text' },
      { name: 'Réf trans', dataField: 'shipment_reference', type: 'text' },
      { name: 'Date enl', dataField: 'pickup_date', type: 'date' },
      { name: 'Date liv', dataField: 'delivery_date', type: 'date' },
      { name: 'CP enl', dataField: 'pickup_postcode', type: 'text' },
      { name: 'CP liv', dataField: 'delivery_postcode', type: 'text' },
      { name: 'Nb palettes', dataField: 'number_of_pallets', type: 'number' },
      { name: 'Poids', dataField: 'weight', type: 'text' },
      { name: 'Prix client', dataField: 'client_price', type: 'currency' },
      { name: 'TVA client', dataField: 'client_vat', type: 'currency' },
      // { 'name': 'Total client', 'dataField': 'client_total', 'type': 'currency' },
      { name: 'Prix tps', dataField: 'carrier_price', type: 'currency' },
      { name: 'TVA tps', dataField: 'carrier_vat', type: 'currency' },
      // { 'name': 'Total tps', 'dataField': 'carrier_total', 'type': 'currency' },
      { name: 'Marge', dataField: 'margin', type: 'currency' },
      { name: 'Taux de marge', dataField: 'margin_rate', type: 'percentage' },
      { name: 'Statut fac', dataField: 'invoicing_status', type: 'text' },
      { name: 'Comm intern', dataField: 'internal_comments', type: 'text' },
      { name: 'Historique', dataField: 'history', type: 'text' },
      // { 'name': 'Nom enl', 'dataField': 'pickup_name', 'type': 'text' },
      // { 'name': 'Nom liv', 'dataField': 'delivery_name', 'type': 'text' },
      { name: 'Date création', dataField: 'entry_date', type: 'date' },
      { name: 'Dernier ordre', dataField: 'last_order_datetime', type: 'date' },
      // { 'name': 'Email transporteur', 'dataField': 'carrier_email', 'type': 'email' },
      // { 'name': 'Heure enl', 'dataField': 'pickup_hour', 'type': 'text' },
      // { 'name': 'Adresse enl 1', 'dataField': 'pickup_address1', 'type': 'text' },
      // { 'name': 'Adresse enl 2', 'dataField': 'pickup_address2', 'type': 'text' },
      // { 'name': 'Ville enl', 'dataField': 'pickup_city', 'type': 'text' },
      // { 'name': 'Contact enl', 'dataField': 'pickup_contact', 'type': 'text' },
      // { 'name': 'Heure liv', 'dataField': 'delivery_hour', 'type': 'text' },
      // { 'name': 'Adresse liv 1', 'dataField': 'delivery_address1', 'type': 'text' },
      // { 'name': 'Adresse liv 2', 'dataField': 'delivery_address2', 'type': 'text' },
      // { 'name': 'Ville liv', 'dataField': 'delivery_city', 'type': 'text' },
      // { 'name': 'Contact liv', 'dataField': 'delivery_contact', 'type': 'text' },
      // { 'name': 'Type de palette', 'dataField': 'pallet_type', 'type': 'text' },
      // { 'name': 'Hauteur', 'dataField': 'pallet_height', 'type': 'number' },
      // { 'name': 'Métrage', 'dataField': 'footage', 'type': 'number' },
      // { 'name': 'Échange palette', 'dataField': 'pallet_exchanger', 'type': 'boolean' },
      // { 'name': 'Semi-taut', 'dataField': 'semi_taut', 'type': 'boolean' },
      // { 'name': 'Porteur-taut', 'dataField': 'porteur_taut', 'type': 'boolean' },
      // { 'name': 'Semi-fourgon', 'dataField': 'semi_fourgon', 'type': 'boolean' },
      // { 'name': 'Porteur-fourgon', 'dataField': 'porteur_fourgon', 'type': 'boolean' },
      // { 'name': 'Semi-frigo', 'dataField': 'semi_frigo', 'type': 'boolean' },
      // { 'name': 'Porteur-frigo', 'dataField': 'porteur_frigo', 'type': 'boolean' },
      // { 'name': '20M3', 'dataField': 'vingt_metres_cube', 'type': 'boolean' },
      // { 'name': 'Plateau', 'dataField': 'plateau', 'type': 'boolean' },
      // { 'name': 'Hayon', 'dataField': 'tail_lift', 'type': 'boolean' },
      // { 'name': 'Transpalette', 'dataField': 'pallet_truck', 'type': 'boolean' },
      // { 'name': 'ADR', 'dataField': 'adr', 'type': 'boolean' },
      // { 'name': 'Classe', 'dataField': 'class_type', 'type': 'text' },
      // { 'name': 'Code UN', 'dataField': 'un_code', 'type': 'text' },
      // { 'name': 'GRP', 'dataField': 'grp', 'type': 'text' },
      // { 'name': 'Commentaires', 'dataField': 'comments', 'type': 'text' },
      { name: 'N° faclient', dataField: 'client_invoice_number', type: 'text' },
      { name: 'Date faclient', dataField: 'client_billing_date', type: 'date' },
      { name: 'Fac réglée', dataField: 'client_has_paid', type: 'boolean' },
      { name: 'Date paimt cli', dataField: 'client_payment_date', type: 'date' },
      { name: 'Tps payé', dataField: 'carrier_has_been_paid', type: 'boolean' },
      { name: 'N° fac tps', dataField: 'carrier_invoice_number', type: 'text' },
      { name: 'Date paimt tps', dataField: 'carrier_payment_date', type: 'date' },
      { name: 'N° paimt tps', dataField: 'carrier_payment_number', type: 'text' },
      { name: 'Date éch tps', dataField: 'carrier_due_date', type: 'date' },
      { name: 'Litige ?', dataField: 'has_dispute', type: 'boolean' },
      { name: 'Enlevé', dataField: 'picked_up_marker', type: 'boolean' },
      { name: 'Marqueurs', dataField: 'markers', type: 'text' },
      { name: 'Actif', dataField: 'shipment_is_active', type: 'boolean' },
      { name: 'Étape', dataField: 'shipment_stage', type: 'text' },
    ].map(col => ({
      ...col,
      placeholder: `Filtrer par ${col.name}`,
    }));

    if (shipmentStage) {
      columns = applyColumnDisplayRules(columns, shipmentStage);
    }
  } else if (data_type === 'client') {
    tableTitle = 'Clients';
    data_identifier = 'client_code';
    columns = [
      { name: 'Code client', dataField: 'client_code', type: 'text' },
      // {'name': 'Date création', 'dataField': 'creation_date', 'type': 'date'},
      // {'name': 'Date modification', 'dataField': 'updated_at', 'type': 'date'},
      { name: 'Nom', dataField: 'name', type: 'text' },
      { name: 'CP', dataField: 'establishment_postcode', type: 'text' },
      { name: 'Ville', dataField: 'establishment_city', type: 'text' },
      { name: 'Téléphone 1', dataField: 'establishment_phone1', type: 'text' },
      { name: 'Téléphone 2', dataField: 'establishment_phone2', type: 'text' },
      { name: 'Email', dataField: 'establishment_email', type: 'email' },
      // {'name': 'Adresse 1 étab', 'dataField': 'establishment_address1', 'type': 'text'},
      // {'name': 'Adresse 2 étab', 'dataField': 'establishment_address2', 'type': 'text'},
      // {'name': 'Pays étab', 'dataField': 'establishment_country', 'type': 'text'},
      // {'name': 'Contact étab', 'dataField': 'establishment_contact', 'type': 'text'},
      // {'name': 'Fax étab', 'dataField': 'establishment_fax', 'type': 'text'},
      // {'name': 'Nom enlèvement', 'dataField': 'pickup_name', 'type': 'text'},
      // {'name': 'CP enlèvement', 'dataField': 'pickup_postcode', 'type': 'text'},
      // {'name': 'Ville enlèvement', 'dataField': 'pickup_city', 'type': 'text'},
      // {'name': 'Téléphone 1 enlèvement', 'dataField': 'pickup_phone1', 'type': 'text'},
      // {'name': 'Téléphone 2 enlèvement', 'dataField': 'pickup_phone2', 'type': 'text'},
      // { name: 'Email enlèvement', dataField: 'pickup_email', type: 'email' },
      // {'name': 'Adresse 1 enlèvement', 'dataField': 'pickup_address1', 'type': 'text'},
      // {'name': 'Adresse 2 enlèvement', 'dataField': 'pickup_address2', 'type': 'text'},
      // {'name': 'Pays enlèvement', 'dataField': 'pickup_country', 'type': 'text'},
      // {'name': 'Contact enlèvement', 'dataField': 'pickup_contact', 'type': 'text'},
      // {'name': 'Fax enlèvement', 'dataField': 'pickup_fax', 'type': 'text'},
      // {'name': 'Nom facturation', 'dataField': 'billing_name', 'type': 'text'},
      // {'name': 'CP facturation', 'dataField': 'billing_postcode', 'type': 'text'},
      // {'name': 'Ville facturation', 'dataField': 'billing_city', 'type': 'text'},
      // {'name': 'Téléphone 1 facturation', 'dataField': 'billing_phone1', 'type': 'text'},
      // {'name': 'Téléphone 2 facturation', 'dataField': 'billing_phone2', 'type': 'text'},
      // {'name': 'Email facturation', 'dataField': 'billing_email', 'type': 'email'},
      // {'name': 'Adresse 1 facturation', 'dataField': 'billing_address1', 'type': 'text'},
      // {'name': 'Adresse 2 facturation', 'dataField': 'billing_address2', 'type': 'text'},
      // {'name': 'Pays facturation', 'dataField': 'billing_country', 'type': 'text'},
      // {'name': 'Contact facturation', 'dataField': 'billing_contact', 'type': 'text'},
      // {'name': 'Fax facturation', 'dataField': 'billing_fax', 'type': 'text'},
      // {'name': 'Carnet d\'emails', 'dataField': 'email_book', 'type': 'text'},
      // {'name': 'Carnet d\'adresses', 'dataField': 'address_book', 'type': 'text'},
      { name: 'Nb doss n-1', dataField: 'completed_shipments_last_month', type: 'number' },
      // {'name': 'SIRET', 'dataField': 'siret_number', 'type': 'text'},
      // {'name': 'Numéro de TVA', 'dataField': 'vat_number', 'type': 'text'},
      // {'name': 'Code APE/NAF', 'dataField': 'ape_naf_code', 'type': 'text'},
      // {'name': 'Type de paiement', 'dataField': 'payment_type', 'type': 'text'},
      // {'name': 'Période', 'dataField': 'period', 'type': 'text'},
      // {'name': 'Taxe gasoil', 'dataField': 'diesel_tax', 'type': 'percentage'},
      // {'name': 'Statut TVA', 'dataField': 'vat_status', 'type': 'boolean'},
      // {'name': 'Date limite de paiement', 'dataField': 'payment_deadline', 'type': 'date'},
      // {'name': 'Facturation automatique', 'dataField': 'automatic_billing', 'type': 'boolean'},
      // {'name': 'Hayon', 'dataField': 'tail_lift', 'type': 'boolean'},
      // {'name': 'Transpalette', 'dataField': 'pallet_truck', 'type': 'boolean'},
      // {'name': 'Échange palette', 'dataField': 'pallet_exchanger', 'type': 'boolean'},
      // {'name': 'ADR', 'dataField': 'adr', 'type': 'boolean'},
      // {'name': 'Classe', 'dataField': 'class_type', 'type': 'text'},
      // {'name': 'Code UN', 'dataField': 'un_code', 'type': 'text'},
      // {'name': 'GRP', 'dataField': 'grp', 'type': 'text'},
      // {'name': 'Commentaires', 'dataField': 'comments', 'type': 'text'},
    ];
    fetchFunction = fetchClientsByPage;
    url = '/clients/';
  } else if (data_type === 'carrier') {
    tableTitle = 'Transporteurs';
    data_identifier = 'carrier_code';
    columns = [
      { name: 'Code tps', dataField: 'carrier_code', type: 'text' },
      // {'name': 'Date création', 'dataField': 'creation_date', 'type': 'date'},
      // {'name': 'Date modification', 'dataField': 'updated_at', 'type': 'date'},
      { name: 'Nom', dataField: 'name', type: 'text' },
      { name: 'CP', dataField: 'establishment_postcode', type: 'text' },
      { name: 'Ville', dataField: 'establishment_city', type: 'text' },
      { name: 'Téléphone 1', dataField: 'establishment_phone1', type: 'text' },
      { name: 'Téléphone 2', dataField: 'establishment_phone2', type: 'text' },
      { name: 'Email', dataField: 'establishment_email', type: 'email' },
      // {'name': 'Adresse 1 étab', 'dataField': 'establishment_address1', 'type': 'text'},
      // {'name': 'Adresse 2 étab', 'dataField': 'establishment_address2', 'type': 'text'},
      // {'name': 'Pays étab', 'dataField': 'establishment_country', 'type': 'text'},
      // {'name': 'Contact étab', 'dataField': 'establishment_contact', 'type': 'text'},
      // {'name': 'Fax étab', 'dataField': 'establishment_fax', 'type': 'text'},
      // {'name': 'Nom facturation', 'dataField': 'billing_name', 'type': 'text'},
      // {'name': 'CP facturation', 'dataField': 'billing_postcode', 'type': 'text'},
      // {'name': 'Ville facturation', 'dataField': 'billing_city', 'type': 'text'},
      // {'name': 'Téléphone 1 facturation', 'dataField': 'billing_phone1', 'type': 'text'},
      // {'name': 'Téléphone 2 facturation', 'dataField': 'billing_phone2', 'type': 'text'},
      { name: 'Email facturation', dataField: 'billing_email', type: 'email' },
      // {'name': 'Adresse 1 facturation', 'dataField': 'billing_address1', 'type': 'text'},
      // {'name': 'Adresse 2 facturation', 'dataField': 'billing_address2', 'type': 'text'},
      // {'name': 'Pays facturation', 'dataField': 'billing_country', 'type': 'text'},
      // {'name': 'Contact facturation', 'dataField': 'billing_contact', 'type': 'text'},
      // {'name': 'Fax facturation', 'dataField': 'billing_fax', 'type': 'text'},
      // {'name': 'Carnet d\'emails', 'dataField': 'email_book', 'type': 'text'},
      { name: 'Nb doss n-1', dataField: 'completed_shipments_last_month', type: 'number' },
      // {'name': 'Numéro SIRET', 'dataField': 'siret_number', 'type': 'text'},
      // {'name': 'Numéro de TVA', 'dataField': 'vat_number', 'type': 'text'},
      // {'name': 'Code APE/NAF', 'dataField': 'ape_naf_code', 'type': 'text'},
      // {'name': 'Type de paiement', 'dataField': 'payment_type', 'type': 'text'},
      // {'name': 'Période', 'dataField': 'period', 'type': 'text'},
      // {'name': 'Statut TVA', 'dataField': 'vat_status', 'type': 'boolean'},
      // {'name': 'Départements de chargement', 'dataField': 'pickup_departments', 'type': 'text'},
      // {'name': 'Départements de livraison', 'dataField': 'delivery_departments', 'type': 'text'},
      // {'name': 'SEMI TAUT', 'dataField': 'semi_taut', 'type': 'text'},
      // {'name': 'PORTEUR TAUT', 'dataField': 'porteur_taut', 'type': 'text'},
      // {'name': 'SEMI FOURGON', 'dataField': 'semi_fourgon', 'type': 'text'},
      // {'name': 'PORTEUR FOURGON', 'dataField': 'porteur_fourgon', 'type': 'text'},
      // {'name': 'SEMI FRIGO', 'dataField': 'semi_frigo', 'type': 'text'},
      // {'name': 'PORTEUR FRIGO', 'dataField': 'porteur_frigo', 'type': 'text'},
      // {'name': '20M3', 'dataField': 'vingt_metre_cube', 'type': 'text'},
      // {'name': 'PLATEAU', 'dataField': 'plateau', 'type': 'text'},
      // {'name': 'Blacklisté', 'dataField': 'is_blacklisted', 'type': 'boolean'},
      // {'name': 'Favori', 'dataField': 'is_favorite', 'type': 'boolean'},
    ];
    fetchFunction = fetchCarrierByPage;
    url = '/transporteurs/';
  } else if (data_type === 'invoice') {
    tableTitle = 'Factures';
    data_identifier = 'invoice_number';
    columns = [
      { name: 'Numéro de Facture', dataField: 'invoice_number', type: 'text' },
      { name: 'Client', dataField: 'client', type: 'text' },
      { name: 'Date de Facturation', dataField: 'billing_date', type: 'date' },
      { name: "Date d'Échéance", dataField: 'due_date', type: 'date' },
      { name: 'Statut', dataField: 'status', type: 'text' },
      { name: 'Échéance', dataField: 'overdue_status', type: 'text' },
      { name: 'Total', dataField: 'total', type: 'currency' },
      { name: 'Dont taxe gasoil', dataField: 'diesel_tax', type: 'currency' },
      { name: 'TVA', dataField: 'vat', type: 'currency' },
      { name: 'Total TTC', dataField: 'total_including_tax', type: 'currency' },
      { name: 'Numéro de Paiement', dataField: 'payment_number', type: 'text' },
      { name: 'Date de Paiement', dataField: 'payment_date', type: 'date' },
      { name: 'Méthode de Paiement', dataField: 'payment_method', type: 'text' },
      { name: 'Période de Facturation', dataField: 'billing_period', type: 'text' },
      { name: 'Mois de Facturation', dataField: 'billing_month', type: 'text' },
      { name: 'Dossiers Associés', dataField: 'related_shipments', type: 'text' },
      { name: 'Avoirs Associés', dataField: 'related_credits', type: 'text' },
    ];
    fetchFunction = fetchInvoiceByPage;
    url = '/factures/';
  }

  return (
    <div className="table-param-setter-div">
      <GenericTable
        data_type={data_type}
        tableTitle={tableTitle}
        data_identifier={data_identifier}
        columns={columns}
        fetchFunction={fetchFunction}
        url={url}
        headerClass={headerClass}
      />
    </div>
  );
}
